// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Row-module-row-2PM2G{display:grid;grid-template-columns:repeat(12, 1fr);grid-gap:var(--des-spacing-grid-layout-primary-2xl);gap:var(--des-spacing-grid-layout-primary-2xl)}", ""]);
// Exports
exports.locals = {
	"row": "Row-module-row-2PM2G"
};
module.exports = exports;
